import { PropertyMetadata } from '../../models/DeviceDetail';
import { UiProfileProperty } from '../../models/UiProfile';

export function overrideNumberUiDefinition(
    uiProperty: UiProfileProperty,
    metadata: PropertyMetadata,
): UiProfileProperty {
    if (!uiProperty.editor) return { ...uiProperty, editable: metadata.editable };

    const editor = {
        ...uiProperty.editor,
        ...(metadata.min != null ? { min: metadata.min } : {}),
        ...(metadata.max != null ? { max: metadata.max } : {}),
    };
    return { ...uiProperty, editable: metadata.editable, editor };
}
